import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from "recharts";

const brl = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
const COLORS = ["#F97316", "#3B82F6", "#10B981", "#F59E0B", "#EF4444"];

export default function Reports() {
  const [sum, setSum] = useState(null);
  useEffect(() => { api.get("/reports/summary").then(({ data }) => setSum(data)); }, []);

  if (!sum) return <div className="p-10 text-center text-muted-foreground">Carregando...</div>;

  const pieData = [
    { name: "Aprovadas", value: sum.approved },
    { name: "Enviadas", value: sum.submitted },
    { name: "Pendentes", value: sum.pending },
    { name: "Rejeitadas", value: sum.rejected },
  ].filter((d) => d.value > 0);

  return (
    <div className="p-6 max-w-7xl mx-auto" data-testid="reports-page">
      <PageHeader title="Relatórios & Analytics" subtitle="Métricas operacionais e custos de manutenção" />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        <Card className="p-4"><div className="text-[10px] uppercase tracking-widest text-muted-foreground font-semibold">Custo Total</div><div className="text-2xl font-display font-extrabold mt-1">{brl(sum.total_cost)}</div></Card>
        <Card className="p-4"><div className="text-[10px] uppercase tracking-widest text-muted-foreground font-semibold">Aprovadas</div><div className="text-2xl font-display font-extrabold mt-1 text-emerald-500">{sum.approved}</div></Card>
        <Card className="p-4"><div className="text-[10px] uppercase tracking-widest text-muted-foreground font-semibold">Rejeitadas</div><div className="text-2xl font-display font-extrabold mt-1 text-red-500">{sum.rejected}</div></Card>
        <Card className="p-4"><div className="text-[10px] uppercase tracking-widest text-muted-foreground font-semibold">Pendentes</div><div className="text-2xl font-display font-extrabold mt-1 text-amber-500">{sum.pending}</div></Card>
      </div>

      <div className="grid lg:grid-cols-2 gap-4">
        <Card className="p-5">
          <h3 className="font-display font-bold text-lg mb-4">Custo por Oficina</h3>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={sum.cost_by_workshop}>
              <XAxis dataKey="workshop" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip formatter={(v) => brl(v)} contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))" }} />
              <Bar dataKey="cost" fill="#F97316" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </Card>

        <Card className="p-5">
          <h3 className="font-display font-bold text-lg mb-4">Distribuição de Status</h3>
          <ResponsiveContainer width="100%" height={280}>
            <PieChart>
              <Pie data={pieData} dataKey="value" nameKey="name" outerRadius={90} label>
                {pieData.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Legend />
              <Tooltip contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))" }} />
            </PieChart>
          </ResponsiveContainer>
        </Card>

        <Card className="p-5 lg:col-span-2">
          <h3 className="font-display font-bold text-lg mb-4">Rejeições por Modelo</h3>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={sum.failure_by_model}>
              <XAxis dataKey="model" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
              <Tooltip contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))" }} />
              <Bar dataKey="failures" fill="#EF4444" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </Card>
      </div>
    </div>
  );
}
